import { Component, OnDestroy, OnInit, ElementRef, ViewChild, Renderer2, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { FileService } from '../../../core/service/file.service';
import { Contract } from '../../model/contract';
import { LeaseAgreementDocumentService } from '../../service/data/lease-agreement-document.service';
import { Subscription } from 'rxjs';
import { LeaseAgreementDocument } from '../../model/lease-agreement-document';
import { SelectionItem } from '../../../core/component/select/select.component';
import { ESignatory, InformationChannelKind, SigningRoleKind } from '../../model/esignatory';
import { LocalDate } from '../../../core/model/local-date';
import { MessageService } from '../../../core/service/message.service';
import { UserAccountService } from '../../../common/service/user-account.service';
import { CooperativeHousingTransferFormService } from '../../service/data/cooperative-housing-transfer-form.service';

@Component({
    selector: 'app-cooperative-housing-transfer-update-form',
    templateUrl: './cooperative-housing-transfer-update-form.component.html',
    styleUrls: ['./cooperative-housing-transfer-update-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CooperativeHousingTransferUpdateFormComponent implements OnDestroy, OnInit {
  constructor(
    private _actionService: ActionWindowService,
    private _dataService: CooperativeHousingTransferFormService,
    private _fb: FormBuilder,
    private _fcf: FormControlExFactory
  ) {}

  isSubmitting: boolean = false;
  public dataContext: any;
  form: FormGroup;
  _subscription: Subscription = new Subscription();

  cancel() {
    this._actionService.close();
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
    this._subscription = null;
  }

  ngOnInit() {
    this.form = this._fb.group({
      ids: this._fcf.createHidden(this.dataContext),
    });
  }

  onSubmit() {
    if (!this.isSubmitting) {
      this.isSubmitting = true;

      if (this.form.valid) {
        if (this.dataContext && Array.isArray(this.dataContext))
          this._subscription.add(
            this._dataService
              .UpdateTransfers(this.dataContext)
              .pipe()
              .subscribe(res => this._actionService.complete(res))
          );
        else if (this.dataContext)
          this._subscription.add(
            this._dataService
              .UpdateTransfer(this.dataContext)
              .pipe()
              .subscribe(res => this._actionService.complete(res))
          );
      }
    }
  }
}
